import formGroupBillingTransactionActualMonth from "./formGroupBillingTransactionActualMonth";
import formGroupBillingTransactionAnual from "./formGroupBillingTransactionAnual";
import formGroupBillingTransactionMonthly from "./formGroupBillingTransactionMonthly";



export default {
    title: 'Billing Summary',
    attributeName: 'billingtransactionssummary',
    getURL: 'billingtransactionssummary',
    createURL: '',
    updateURL: '',
    removeURL: '',
    sessionParams: [],
    noArea:true,
    goBack: true,
    formConfig: [
      formGroupBillingTransactionAnual, 
      formGroupBillingTransactionActualMonth, 
      formGroupBillingTransactionMonthly
    ]
  };
  